"use client";

import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormDescription, FormMessage } from "@/components/ui/form";
import { DateTimePicker } from "@/components/ui/date/DateTimePicker";
import { Input } from "@/components/ui/input";
import { Control } from "react-hook-form";
import type { CommunicationFormValues } from "./communicationFormSchema";

interface DateTimeAndExternalProps {
  control: Control<CommunicationFormValues>;
  isSubmitting: boolean;
}

export function DateTimeAndExternalFields({
  control,
  isSubmitting,
}: DateTimeAndExternalProps) {
  return (
    <>
      <FormField
        control={control}
        name="occurred_at"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Date & Time</FormLabel>
            <FormControl>
              <DateTimePicker value={field.value} onChange={field.onChange} />
            </FormControl>
            <FormDescription>When this communication took place</FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="external_id"
        render={({ field }) => (
          <FormItem>
            <FormLabel>External Reference (Optional)</FormLabel>
            <FormControl>
              <Input
                placeholder="Email ID, ticket number, meeting ID, etc."
                {...field}
                disabled={isSubmitting}
              />
            </FormControl>
            <FormDescription>
              Reference ID from external systems (email, calendar, etc.)
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
}
